<button id="click-dns-cookie" class="click-dns-cookie">
  {{ 'common.cookieText' | cxTranslate }}
</button>
